import { Injectable } from '@angular/core';
import { SecretarySettings } from '../interfaces/secretaries-settings';

@Injectable({
  providedIn: 'root',
})
export class SecretariesSettingsAdapter {

  public adapterToModel(secretarySettingsAPI: SecretarySettings): SecretarySettings {
      return secretarySettingsAPI
  }

  public adaptToAPIFormat(secretarySettingsModel: SecretarySettings): SecretarySettings {
    
    return secretarySettingsModel

  }
}
